var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xl-3 mb-3"
  }, [_c('h5', {
    staticClass: "title-section"
  }, [_vm._v("Enrollment by Tier")]), _c('div', {
    staticClass: "overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.memberDataByTier, function (data, tier) {
    return _c('tr', {
      key: tier
    }, [_c('td', [_vm._v(_vm._s(_vm.formatTierName(tier)))]), _c('td', [_vm._v(_vm._s(data.active))])]);
  }), 0)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tier")]), _c('th', [_vm._v("Enrolled")])])]);
}]

export { render, staticRenderFns }